import React from "react";

export function TimelineBlock({ date, children }) {
  return (
    <div className="relative pl-8 pb-7 last:pb-0 group/block">
      {/* Vertical connector — hidden on last sibling via CSS */}
      <div className="absolute left-[6px] top-4 bottom-0 w-px bg-gray-200 group-last/block:hidden" />
      {/* Dot */}
      <div className="absolute left-0 top-[10px] w-3 h-3 rounded-full bg-arsen-primary border-2 border-white ring-2 ring-arsen-primary-100" />
      {/* Content — always left-aligned regardless of parent text-center */}
      <div className="pt-0.5 space-y-0.5 text-left">
        <span className="inline-block text-[11px] font-bold text-arsen-primary bg-arsen-primary-50 px-2.5 py-0.5 rounded-full">
          {date}
        </span>
        <p className="text-sm text-gray-600 font-medium pl-0.5">{children}</p>
      </div>
    </div>
  );
}

export function Timeline({ month, children }) {
  return (
    <div data-aos="fade-up" className="mb-6 text-left">
      {/* Month label */}
      <div className="flex items-center gap-3 mb-5">
        <span className="text-[11px] font-bold tracking-widest text-white bg-arsen-quaternary-950 px-3 py-1 rounded-full uppercase">
          {month}
        </span>
        <div className="flex-1 h-px bg-gray-100" />
      </div>
      {/* Items */}
      <div className="relative">
        {children}
      </div>
    </div>
  );
}
